export function veryifyEmailPattern(email: string) {
    const regExp: RegExp = /\b[\w.-]+@[\w.-]+\.\w{2,4}\b/;
    return regExp.test(email);
}
